import React from 'react';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Screenshots from '../components/Screenshots';
import ProjectManagement from '../components/ProjectManagement';
import Pricing from '../components/Pricing';
import Benefits from '../components/Benefits';
import FAQ from '../components/FAQ';
import FinalCTA from '../components/FinalCTA';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HomeBlogGrid from '../components/HomeBlogGrid';

const LandingPage: React.FC = () => {
  return (
    <div>
      <Navbar />
      <Hero />
      <Features />
      <Screenshots />
      <Benefits />
      <ProjectManagement />
      <Pricing />
      <HomeBlogGrid />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
};

export default LandingPage;
